import React, { useEffect, useRef } from "react";
import { GalleryPermissionScreenProps } from "./types";

const GalleryPermissionScreen: React.FC<GalleryPermissionScreenProps> = ({
  navigateToStep,
  onImageSelect,
  logStep,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Check if gallery permission is already granted on mount
  useEffect(() => {
    const galleryPermission = localStorage.getItem("galleryPermissionGranted");
    if (galleryPermission === "true") {
      // Permission already granted - log it
      if (logStep) {
        logStep("gallery_permission_granted");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Trigger file input when OK is clicked
  const handleOkClick = () => {
    // Store permission in localStorage
    localStorage.setItem("galleryPermissionGranted", "true");

    // Log gallery permission granted (non-blocking)
    if (logStep) {
      logStep("gallery_permission_granted");
    }

    // Trigger file input
    fileInputRef.current?.click();
  };

  // Handle Don't Allow click
  const handleDontAllow = () => {
    // Log gallery permission denied (non-blocking)
    if (logStep) {
      logStep("gallery_permission_denied", {
        error_message: "User denied gallery permission",
      });
    }

    // Navigate to permission denied page
    navigateToStep("permissionDenied");
  };

  // Handle file selection
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && onImageSelect) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        onImageSelect(base64String);
      };
      reader.readAsDataURL(file);
    }
  };
  return (
    <div
      className="d-md-none w-100"
      style={{
        backgroundColor: "transparent",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        fontFamily: "Sweet Sans Pro Regular",
      }}
    >
      <div
        style={{
          backgroundColor: "transparent",
          borderRadius: "20px",
          padding: "20px",
          textAlign: "left",
          maxWidth: "300px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <h3
          style={{
            fontSize: "18px",
            fontWeight: "400",
            marginBottom: "8px",
            color: "#000",
          }}
        >
          &ldquo;Senco Gold&rdquo; Would Like to Access Your Photos
        </h3>
        <p
          style={{
            fontSize: "13px",
            color: "#666",
            marginBottom: "20px",
            lineHeight: "1.4",
          }}
        >
          This app requires access to your gallery
        </p>
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          <button
            onClick={handleDontAllow}
            style={{
              flex: 1,
              padding: "9px 10px",
              backgroundColor: "#f0f0f0",
              border: "none",
              borderRadius: "20px",
              fontSize: "15px",
              fontWeight: "500",
              color: "#333",
              cursor: "pointer",
              fontFamily: "Sweet Sans Pro Regular",
            }}
          >
            Don&apos;t Allow
          </button>
          <button
            onClick={handleOkClick}
            style={{
              flex: 1,
              padding: "9px 10px",
              backgroundColor: "#007AFF",
              border: "none",
              borderRadius: "20px",
              fontSize: "15px",
              fontWeight: "500",
              color: "white",
              cursor: "pointer",
              fontFamily: "Sweet Sans Pro Regular",
            }}
          >
            OK
          </button>
        </div>

        {/* Hidden file input */}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </div>
    </div>
  );
};

export default GalleryPermissionScreen;
